'use strict';
/**
 * This hides or removes components based on whether a feature is enabled. 
 *
 * This uses the features config from the backend's YML file.
 *
 * Usage : 
 * div.to-remove-if-feature-disabled(ms-feature-enabled="featureName")
 *
 * In YML, add a "features" section:
 * features:
 *   sleep: true
 * 
 */

(function () {

  angular.module('msCore').directive('msFeatureEnabled', featureEnabled);

  featureEnabled.$inject = ['msConfig'];

  function featureEnabled(msConfig) {
    var directive = {
      link: link,
      restrict: 'A'
    };
    return directive;

    function link(scope, element, attrs) {
      var feature = attrs.msFeatureEnabled;
      var requiresFeature = true;
      // Turn on if NOT feature when prefixed with !
      if (feature.charAt(0) === '!') {
        feature = feature.substring(1);
        requiresFeature = false;
      }
      msConfig('features').then(function (features) {
        if (!features || features[feature] !== requiresFeature) {
          element.remove();
        }
      }, function () {
        // Something went wrong, remove the feature in case
        element.remove();
      });
    }
  }
})();